export const services = [
  {
    icon: '⚡',
    title: 'CRM Reset',
    subtitle: 'Eenmalige opschoning',
    price: '€1.500 – €5.000',
    features: [
      'Duplicaten samenvoegen',
      'Verouderde records opschonen',
      'Velden normaliseren',
      'Statussen & pipelines corrigeren',
      'Rapportages controleren'
    ],
    highlight: 'Perfect als startpunt'
  },
  {
    icon: '∞',
    title: 'Doorlopend Beheer',
    subtitle: 'Maandelijks pakket',
    price: 'Vanaf €500/maand',
    features: [
      'Datakwaliteit bewaken',
      'Nieuwe data controleren',
      'Periodieke opschoning',
      'Rapportages onderhouden',
      'Gebruikerssupport'
    ],
    highlight: 'Meest gekozen',
    popular: true
  },
  {
    icon: '↗',
    title: 'Datamigraties',
    subtitle: 'Verbetertrajecten',
    price: 'Vanaf €3.000',
    features: [
      'Excel → CRM migratie',
      'Oud CRM → nieuw CRM',
      'Herstructurering velden',
      'Salesprocessen vertalen'
    ],
    highlight: 'Voor groei'
  }
];
